import { h } from './dom';

interface Project {
  n: string;
  title: string;
  desc: string;
  tags: string;
  featured?: boolean;
}

const PROJECTS: Project[] = [
  {
    n: '014',
    title: 'Agent Loop',
    desc: 'A daemon that holds a conversation. Persistent state, hundreds of concurrent contexts, sub-second turnaround.',
    tags: 'TYPESCRIPT · POSTGRES',
    featured: true,
  },
  {
    n: '013',
    title: 'Ladder Engine',
    desc: 'Competitive matchmaking with provably-fair ranking. Holds under thousands of concurrent matches.',
    tags: 'PYTHON · REDIS',
  },
  {
    n: '012',
    title: 'Price Oracle',
    desc: 'Live marketplace intel from three independent feeds, normalized into one continuously-updated index.',
    tags: 'NODE · CLOUDFLARE WORKERS',
  },
  {
    n: '011',
    title: 'CTF Notebook',
    desc: 'Running record of solved jeopardy: reverse engineering, web exploitation, applied crypto.',
    tags: 'SECURITY · WRITEUPS',
  },
];

function Row(p: Project): HTMLElement {
  const desc = h('span', { class: 's-work-row__desc' }, p.desc);
  desc.append(h('span', { class: 'tags' }, p.tags));

  return h('li', { class: `s-work-row${p.featured ? ' s-work-row--featured' : ''}` },
    h('span', { class: 's-work-row__n' }, p.n),
    h('span', { class: 's-work-row__title' }, p.title),
    desc,
    h('span', { class: 's-work-row__arrow' }, '↗'),
  );
}

export function Work(): HTMLElement {
  const list = h('ul', { class: 's-work-list' }, ...PROJECTS.map(Row));

  const caption = h('div', { class: 's-section__caption' });
  caption.append('// 04 PROJECTS', h('br'), 'SELECTED · NOT EXHAUSTIVE');

  const title = h('h2', { class: 's-section__title' });
  title.append('Selected ', h('b', {}, 'work.'), h('br'), 'Things shipped, with our names on them.');

  return h('section', { id: 'work', class: 's-section' },
    caption,
    h('header', { class: 's-section__head' },
      h('span', { class: 's-section__num' }, '01'),
      title,
    ),
    list,
  );
}
